import { Document, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";
import FoodSafetyData from "../../data/food-safety.data";

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
    fontFamily: "Helvetica",
    fontSize: 11,
    paddingTop: 30,
    paddingLeft: 50,
    paddingRight: 50,
    lineHeight: 1.5,
    flexDirection: "column",
  },
  logo: {
    width: 84,
    height: 70,
    marginLeft: "auto",
    marginRight: "auto",
  },
  titleContainer: {
    marginTop: 24,
  },
  reportTitle: {
    color: "#3778C2",
    letterSpacing: 4,
    fontSize: 25,
    textAlign: "center",
    textTransform: "uppercase",
  },
  reportDescription: {
    fontSize: 12,
    marginBottom: 10,
  },
  row: {
    flexDirection: "column",
    borderBottomWidth: 1,
    fontSize: 12,
    fontStyle: "bold",
  },
  description: {
    width: "100%",
  },
  total: {
    width: "100%",
  },
});

export type updateFoodSafetyTypes = {
  formData: {
    eventDate: string;
    type: string;
    cause: string;
    actionTaken: string;
    printeventDate: string;
    printtype: string;
    printcause: string;
    printactionTaken: string;
  };
};

export const FoodSafetyPDF = ({ formData }: updateFoodSafetyTypes) => {
  const { t } = useTranslation();

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.titleContainer}>
          <Text style={styles.reportTitle}>{t(FoodSafetyData.title)}</Text>
          <Text style={styles.reportDescription}>
            {t(FoodSafetyData.description.i18nKey)}
          </Text>
        </View>
        {FoodSafetyData.fields.map((field, index) => {
          if (field.name === "eventDate" && formData["printeventDate"]) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>
                  {t(formData["eventDate"])}
                </Text>
              </View>
            );
          } else if (field.name === "type" && formData["printtype"]) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>{t(formData["type"])}</Text>
              </View>
            );
          } else if (field.name === "cause" && formData["printcause"]) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>{t(formData["cause"])}</Text>
              </View>
            );
          } else if (
            field.name === "actionTaken" &&
            formData["printactionTaken"]
          ) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>
                  {t(formData["actionTaken"])}
                </Text>
              </View>
            );
          }
          return null;
        })}
      </Page>
    </Document>
  );
};
